import React, { FC } from 'react';

const ConfettiBackground: FC = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 399 574"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Confetti Background - Version 4</title>
      <defs>
        <polygon
          id="path-1"
          points="6.84644614e-05 0.420832797 22.6747204 0.420832797 22.6747204 17.9565763 6.84644614e-05 17.9565763"
        />
        <polygon
          id="path-3"
          points="0.190495519 0.494878375 36.9837977 0.494878375 36.9837977 41.2337951 0.190495519 41.2337951"
        />
        <polygon
          id="path-5"
          points="0 0.0372660513 33.759559 0.0372660513 33.759559 23.6676026 0 23.6676026"
        />
        <filter
          x="0.0%"
          y="0.0%"
          width="100.0%"
          height="100.0%"
          filterUnits="objectBoundingBox"
          id="filter-7"
        >
          <feGaussianBlur stdDeviation="0" in="SourceGraphic" />
        </filter>
        <polygon
          id="path-8"
          points="0.378256119 0.000100570835 16.9441429 0.000100570835 16.9441429 20.2007586 0.378256119 20.2007586"
        />
        <polygon
          id="path-10"
          points="0.467257559 0.000120685003 20.931 0.000120685003 20.931 24.2409103 0.467257559 24.2409103"
        />
        <polygon
          id="path-12"
          points="0.311505039 8.54852102e-05 13.954 8.54852102e-05 13.954 17.1706448 0.311505039 17.1706448"
        />
        <polygon
          id="path-14"
          points="8.64079586e-05 0.305042371 21.7586286 0.305042371 21.7586286 27.0598404 8.64079586e-05 27.0598404"
        />
        <polygon
          id="path-16"
          points="0 8.59042553e-05 21.999837 8.59042553e-05 21.999837 20.6170213 0 20.6170213"
        />
        <polygon
          id="path-18"
          points="0.278482093 0.0751508834 11.7122571 0.0751508834 11.7122571 9.66422872 0.278482093 9.66422872"
        />
        <polygon
          id="path-20"
          points="0.379318182 0.272183106 19.9913636 0.272183106 19.9913636 22.6785873 0.379318182 22.6785873"
        />
        <polygon
          id="path-22"
          points="0 0.317928687 17.8727077 0.317928687 17.8727077 13.0805936 0 13.0805936"
        />
        <polygon
          id="path-24"
          points="0 0.410701637 24.6462037 0.410701637 24.6462037 17.5242883 0 17.5242883"
        />
        <polygon id="path-26" points="0 7.91666667e-05 22 7.91666667e-05 22 19 0 19" />
      </defs>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Components/WelcomeBackRolls" transform="translate(10.000000, 18.000000)">
          <g transform="translate(-10.000000, -29.000000)" id="Welcome_Back">
            <g>
              <g id="Confetti_4">
                <g id="Confetti">
                  <path
                    d="M49,256.295285 C51.0345689,257.749263 52.2536443,261.842926 52.2536443,261.842926 C55.5860058,261.842926 61,262.77766 61,262.77766 C61,259.038727 57.668055,253.897695 57.668055,253.897695 C57.668055,253.897695 52.6734694,252.965766 49,256.295285"
                    id="Fill-1"
                    fill="#A94B7D"
                  />
                  <g id="Group-5" transform="translate(34.000000, 249.777660)">
                    <mask id="mask-2" fill="white">
                      <use xlinkHref="#path-1" />
                    </mask>
                    <g id="Clip-4" />
                    <path
                      d="M22.6747204,4.60411338 C22.6747204,4.60411338 9.89694259,2.30196461 9.89694259,17.9565763 C9.89694259,17.9565763 1.80435,17.0357168 0.100646296,17.0357168 C0.100646296,17.0357168 -1.2644463,6.26304179 6.06360926,2.30196461 C14.5821278,-2.30233295 20.9710167,2.76239436 22.6747204,4.60411338"
                      id="Fill-3"
                      fill="#C5679B"
                      mask="url(#mask-2)"
                    />
                  </g>
                  <g transform="translate(375.658888, 250.304754) rotate(18.000000) translate(-375.658888, -250.304754) translate(350.158888, 226.304754)">
                    <g id="Group-3" transform="translate(13.618467, 5.572058)">
                      <mask id="mask-4" fill="white">
                        <use xlinkHref="#path-3" />
                      </mask>
                      <g id="Clip-2" />
                      <path
                        d="M0.190495519,0.503632596 C0.190495519,0.503632596 26.4169104,7.97936451 21.1613944,41.2337951 L36.9756965,25.738042 C36.9756965,25.738042 38.5123572,-0.0489035745 0.190495519,0.503632596"
                        id="Fill-1"
                        fill="#FACB02"
                        mask="url(#mask-4)"
                      />
                    </g>
                    <g id="Group-6" transform="translate(0.675633, 0.203563)">
                      <mask id="mask-6" fill="white">
                        <use xlinkHref="#path-5" />
                      </mask>
                      <g id="Clip-5" />
                      <path
                        d="M33.759559,23.6676026 C27.6796615,9.72734252 14.6759692,5.96014401 14.6759692,5.96014401 C14.7936615,5.95843282 14.9069949,5.96014401 15.0238154,5.95928841 C7.60048205,3.89558576 5.74007179,0.0368382522 5.74007179,0.0368382522 L-0.000697435898,18.0172327 C4.31817436,21.3814445 13.3299179,24.6002046 21.374841,22.9215211 C28.2942769,21.4772714 32.6689436,23.1662221 33.759559,23.6676026"
                        id="Fill-4"
                        fill="#E6A501"
                        filter="url(#filter-7)"
                        mask="url(#mask-6)"
                      />
                    </g>
                  </g>
                  <g>
                    <g id="confetti" transform="translate(28.000000, 0.771277)">
                      <g id="Group-3">
                        <mask id="mask-9" fill="white">
                          <use xlinkHref="#path-8" />
                        </mask>
                        <g id="Clip-2" />
                      </g>
                    </g>
                    <g id="confetti" transform="translate(4.000000, 554.443617)">
                      <g id="Group-3" transform="translate(7.000000, 0.000000)">
                        <mask id="mask-11" fill="white">
                          <use xlinkHref="#path-10" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M2.20164,24.2409103 C5.33124,20.5165711 8.02104,18.8891339 11.93124,18.1028711 C17.93124,16.896021 20.93124,11.4651959 20.93124,11.4651959 L12.53124,0.000120685003 C10.29084,3.37869733 7.03704,5.05380517 1.73124,7.24122084 C-0.66876,15.085746 0.84504,20.8828501 2.20164,24.2409103"
                          id="Fill-1"
                          fill="#E6A501"
                          mask="url(#mask-11)"
                        />
                      </g>
                      <path
                        d="M10.3849754,7.21595745 C10.3849754,7.21595745 -5.30517192,14.3776596 1.88614562,29.8946809 L13,27.5074468 C13,27.5074468 6.4624386,20.3457447 10.3849754,7.21595745"
                        id="Fill-4"
                        fill="#FACB02"
                      />
                    </g>
                    <g id="confetti" transform="translate(309.000000, 13.141489)">
                      <g id="Group-3" transform="translate(5.000000, 0.000000)">
                        <mask id="mask-13" fill="white">
                          <use xlinkHref="#path-12" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M1.46776,17.1706448 C3.55416,14.5325712 5.34736,13.3798032 7.95416,12.822867 C11.95416,11.9680149 13.95416,8.12118045 13.95416,8.12118045 L8.35416,8.54852102e-05 C6.86056,2.39324394 4.69136,3.57977866 1.15416,5.1291981 C-0.44584,10.6857368 0.56336,14.7920188 1.46776,17.1706448"
                          id="Fill-1"
                          fill="#E6A501"
                          mask="url(#mask-13)"
                        />
                      </g>
                      <path
                        d="M6.39075412,5.15425532 C6.39075412,5.15425532 -3.26472118,10.037234 1.160705,20.6170213 L8,18.9893617 C8,18.9893617 3.97688529,14.106383 6.39075412,5.15425532"
                        id="Fill-4"
                        fill="#FACB02"
                      />
                    </g>
                    <g id="confetti" transform="translate(17.000000, 53.856383)">
                      <g id="Group-3">
                        <mask id="mask-15" fill="white">
                          <use xlinkHref="#path-14" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M21.7586286,17.3632906 C21.7586286,17.3632906 8.00683265,14.189951 6.69446531,0.305042371 L0.0994040816,6.00090946 C0.0994040816,6.00090946 -2.08847347,18.9423928 14.0734449,27.0598863 C14.0734449,27.0598863 21.1745061,17.6178365 21.7586286,17.3632906"
                          id="Fill-1"
                          fill="#2E87C9"
                          mask="url(#mask-15)"
                        />
                      </g>
                      <path
                        d="M0.0933106461,5.79926519 L0.479257893,5.452397 C1.99675158,4.58252365 6,5.89296465 6,5.89296465 C3.37767931,8.09760483 2.48024593,16.1404421 2.4416512,16.493617 C-0.717602691,10.7991224 0.0933106461,5.79926519 0.0933106461,5.79926519"
                        id="Fill-4"
                        fill="#3365A6"
                      />
                    </g>
                    <g id="confetti" transform="translate(232.000000, 36.000000)">
                      <g id="Group-3">
                        <mask id="mask-17" fill="white">
                          <use xlinkHref="#path-16" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M-0.000162962963,9.44955399 C-0.000162962963,9.44955399 12.6294667,11.5971604 18.3331704,8.59042553e-05 L21.999837,7.30194761 C21.999837,7.30194761 19.5553926,19.3285434 3.2590963,20.6171072 C3.2590963,20.6171072 0.407244444,9.87907527 -0.000162962963,9.44955399"
                          id="Fill-1"
                          fill="#89C79D"
                          mask="url(#mask-17)"
                        />
                      </g>
                      <path
                        d="M22,7.42548909 L21.7606691,6.94716725 C20.6459361,5.52673766 16.4241904,5.15425532 16.4241904,5.15425532 C18.1020802,8.26402859 16.089213,16.147481 16,16.493617 C20.9860605,12.4272001 22,7.42548909 22,7.42548909"
                        id="Fill-4"
                        fill="#56A285"
                      />
                    </g>
                    <g id="confetti" transform="translate(326.000000, 40.560638)">
                      <g id="Group-3" transform="translate(7.000000, 17.524468)">
                        <mask id="mask-19" fill="white">
                          <use xlinkHref="#path-18" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M0.390257143,0.0751508834 C2.59182857,1.30618954 6.46997143,0.457118019 6.46997143,0.457118019 C8.18425714,3.6458533 11.7122571,8.36659893 11.7122571,8.36659893 C8.74311429,10.2074044 2.94625714,9.55023684 2.94625714,9.55023684 C2.94625714,9.55023684 -0.364028571,5.2298664 0.390257143,0.0751508834"
                          id="Fill-1"
                          fill="#3365A6"
                          mask="url(#mask-19)"
                        />
                      </g>
                      <path
                        d="M9.83394712,26.8021277 C9.83394712,26.8021277 1.87173611,16.2074382 14,8.5366665 C14,8.5366665 9.37384419,1.56258132 8.55002515,0 C8.55002515,0 -0.456788397,4.02625272 0.0181432782,12.6901638 C0.570102034,22.7618871 7.5828616,26.1415388 9.83394712,26.8021277"
                        id="Fill-4"
                        fill="#2E87C9"
                      />
                    </g>
                    <g id="confetti" transform="translate(0.000000, 92.262766)">
                      <g id="Group-3" transform="translate(7.000000, 3.092553)">
                        <mask id="mask-21" fill="white">
                          <use xlinkHref="#path-20" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M0.379318182,0.276997928 C0.379318182,0.276997928 14.3588636,4.38865048 11.5575,22.6785873 L19.9870455,14.1559231 C19.9870455,14.1559231 20.8061364,-0.026896966 0.379318182,0.276997928"
                          id="Fill-1"
                          fill="#FACB02"
                          mask="url(#mask-21)"
                        />
                      </g>
                      <g id="Group-6">
                        <mask id="mask-23" fill="white">
                          <use xlinkHref="#path-22" />
                        </mask>
                        <g id="Clip-5" />
                        <path
                          d="M17.8727077,13.0805936 C14.6539385,5.55150622 7.76963077,3.51685504 7.76963077,3.51685504 C7.83193846,3.51593083 7.89193846,3.51685504 7.95378462,3.51639294 C4.02378462,2.40179411 3.03886154,0.317697634 3.03886154,0.317697634 L-0.000369230769,10.0288479 C2.28609231,11.8458473 7.05701538,13.5842887 11.3160923,12.6776374 C14.9793231,11.8976031 17.2953231,12.8097997 17.8727077,13.0805936"
                          id="Fill-4"
                          fill="#E6A501"
                          mask="url(#mask-23)"
                        />
                      </g>
                    </g>
                    <g id="confetti" transform="translate(42.000000, 25.542553)">
                      <path
                        d="M15,6.71870138 C17.2041163,8.21753553 18.5247813,12.4374932 18.5247813,12.4374932 C22.1343884,12.4374932 28,13.4010638 28,13.4010638 C28,9.54678124 24.3903929,4.24714267 24.3903929,4.24714267 C24.3903929,4.24714267 18.9795918,3.28646274 15,6.71870138"
                        id="Fill-1"
                        fill="#E6A501"
                      />
                      <g id="Group-5">
                        <mask id="mask-25" fill="white">
                          <use xlinkHref="#path-24" />
                        </mask>
                        <g id="Clip-4" />
                        <path
                          d="M24.6462037,4.49327362 C24.6462037,4.49327362 10.7573148,2.24654694 10.7573148,17.5242883 C10.7573148,17.5242883 1.96101852,16.6255977 0.109166667,16.6255977 C0.109166667,16.6255977 -1.37462963,6.11226486 6.59064815,2.24654694 C15.8499074,-2.24690642 22.7943519,2.69589227 24.6462037,4.49327362"
                          id="Fill-3"
                          fill="#FACB02"
                          mask="url(#mask-25)"
                        />
                      </g>
                    </g>
                    <g id="confetti" transform="translate(175.000000, 11.079787)" fill="#81C596">
                      <path
                        d="M15.4186342,21.5103533 C11.0027282,22.0810861 6.47704302,23.1429857 1.94517309,24.7404255 C0.3247706,17.7187289 -0.327719714,10.1416006 0.156236372,2.25232892 C5.52304652,0.959381954 10.834194,0.223396755 16,-3.21520588e-13 C14.6903808,7.44094807 14.5465856,14.6998125 15.4186342,21.5103533"
                        id="Fill-26"
                      />
                    </g>
                    <g id="confetti" transform="translate(367.000000, 58.000000)" fill="#81C596">
                      <path
                        d="M0,14.0279002 C0.768992457,9.74110191 1.12015086,5.20492886 0.986799569,0.49893617 C7.85735453,1.12619787 14.953125,2.82745401 22,5.6791999 C21.6132812,11.0675309 20.7346444,16.2386152 19.4307651,21.1159574 C13.0313847,17.6308302 6.46012931,15.2870133 0,14.0279002"
                        id="Fill-3"
                      />
                    </g>
                    <g transform="translate(95.000000, 47.303191)">
                      <g id="Group-3">
                        <mask id="mask-27" fill="white">
                          <use xlinkHref="#path-26" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M0,8.7084125 C0,8.7084125 12.6296296,10.6875792 18.3333333,7.91666667e-05 L22,6.72924583 C22,6.72924583 19.5555556,17.8125792 3.25925926,19.0000792 C3.25925926,19.0000792 0.407407407,9.10424583 0,8.7084125"
                          id="Fill-1"
                          fill="#2E87C9"
                          mask="url(#mask-27)"
                        />
                      </g>
                      <path
                        d="M23,5.00296439 L22.8005718,4.58114009 C21.8716941,3.32848616 18.3538242,3 18.3538242,3 C19.7519657,5.74245884 18.0746962,12.6951488 18,13 C22.1551108,9.41389256 23,5.00296439 23,5.00296439"
                        id="Fill-4"
                        fill="#3365A6"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ConfettiBackground;
